<template>
  <v-card class="notes-column" flat>
    <div class="notes-column-header">
      <div class="notes-title">
        {{ title }}
        <span class="notes-count">({{ total }})</span>
      </div>
      <div class="notes-column-actions">
        <v-menu v-model="filtersMenu" offset-y left :close-on-content-click="false" :close-on-click="false" @click:outside="filtersMenu = false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <notes-filters
            :value="filters"
            :company="company"
            :hide-from-user="hideFromUser"
            :hide-to-user="hideToUser"
            @apply="applyFilters"
          />
        </v-menu>
      </div>
    </div>
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <v-list v-if="notes.length" style="background:transparent;">
      <note-card
        v-for="note in notes"
        :key="note.id"
        :note="note"
        :allow-read-actions="allowReadActions"
        :allow-edit="allowEdit && isOwner(note)"
        
        @mark-read="$emit('mark-read', $event)"
        @mark-done="$emit('mark-done', $event)"
        @edit="$emit('edit', $event)"
        
      />
      <!--
      :allow-delete="allowDelete && isOwner(note)"
      @delete="$emit('delete', $event)"
      -->
    </v-list>
    <div v-else class="notes-empty">Sin notas.</div>
    <div class="notes-pagination" v-if="page < lastPage">
      <v-btn text small @click="$emit('load-more')" :loading="loading">Ver mas</v-btn>
    </div>
  </v-card>
</template>

<script>
import NotesFilters from './NotesFilters'
import NoteCard from './NoteCard'

export default {
  components: {
    NotesFilters,
    NoteCard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    notes: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    lastPage: {
      type: Number,
      default: 1,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    company: {
      type: [String, Object],
      default: null,
    },
    allowReadActions: {
      type: Boolean,
      default: false,
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
    allowDelete: {
      type: Boolean,
      default: false,
    },
    hideFromUser: {
      type: Boolean,
      default: false,
    },
    hideToUser: {
      type: Boolean,
      default: false,
    },
    currentUserId: {
      type: [String, Number],
      default: null,
    },
  },
  data: () => ({
    filtersMenu: false,
  }),
  methods: {
    isOwner(note) {
      if (!this.currentUserId || !note.from_user) {
        return false
      }
      return String(note.from_user.id) === String(this.currentUserId)
    },
    applyFilters(filters) {
      this.filtersMenu = false
      this.$emit('apply-filters', filters)
    },
  },
}
</script>

<style scoped>
.notes-column {
  background: #fff8e1;
  border-radius: 12px;
  min-height: 60vh;
}
.notes-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
}
.notes-title {
  font-weight: 700;
  color: #5a4b1a;
}
.notes-count {
  margin-left: 6px;
  color: #e25104;
  font-weight: 700;
}
.notes-empty {
  padding: 16px;
  color: #6f6f6f;
}
.notes-pagination {
  display: flex;
  justify-content: center;
  padding: 8px 0 16px;
}
</style>
